/* Chattitude — animations, effets au scroll et ajout au panier */
(function () {
  'use strict';

  var de = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var state = { globals: false, lastY: 0, toastTimer: 0 };
  var revealObserver = null;

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function one(sel, root) { return (root || document).querySelector(sel); }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* Manifeste : chaque mot s'allume pendant le scroll */
  function initManifesto() {
    all('.ct-manif-text').forEach(function (m) {
      if (!once(m, 'ctWords')) return;
      var gold = (m.getAttribute('data-gold') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var words = m.textContent.trim().split(/\s+/);
      m.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        var bare = w.replace(/[.,;:!?…«»"]/g, '').toLowerCase();
        s.className = 'ct-w' + (gold.indexOf(bare) > -1 ? ' ct-g' : '');
        s.textContent = w;
        m.appendChild(s);
        if (i < words.length - 1) m.appendChild(document.createTextNode(' '));
      });
    });
    lit();
  }

  function lit() {
    all('.ct-manif-text').forEach(function (m) {
      var ws = all('.ct-w', m);
      if (!ws.length) return;
      if (reduce) { ws.forEach(function (w) { w.classList.add('ct-on'); }); return; }
      var r = m.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var k = Math.round(p * ws.length);
      ws.forEach(function (w, i) { w.classList.toggle('ct-on', i < k); });
    });
  }

  /* Apparitions au scroll */
  function initReveal() {
    if (reduce) return;
    de.classList.add('ct-motion');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { de.classList.add('ct-go'); });
    });
    if (!('IntersectionObserver' in window)) {
      all('.ct-rv,.ct-arch').forEach(function (e) { e.classList.add('ct-in'); });
      return;
    }
    revealObserver = revealObserver || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ct-in');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    all('.ct-rv').forEach(function (el) { if (once(el, 'ctRv')) revealObserver.observe(el); });
    all('.ct-arches').forEach(function (grid) {
      if (!once(grid, 'ctArches')) return;
      var ao = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            all('.ct-arch', grid).forEach(function (a) { a.classList.add('ct-in'); });
            ao.disconnect();
          }
        });
      }, { threshold: 0.1 });
      ao.observe(grid);
    });
  }

  /* Hero : la lumière suit le curseur (ou se balade seule sur mobile) */
  function initHero() {
    all('.ct-hero').forEach(function (hero) {
      if (!once(hero, 'ctHero')) return;
      function setLight(x, y) {
        hero.style.setProperty('--mx', x + 'px');
        hero.style.setProperty('--my', y + 'px');
      }
      if (fine) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          setLight(e.clientX - r.left, e.clientY - r.top);
        });
      } else if (!reduce) {
        var a = 0;
        (function loop() {
          if (!document.body.contains(hero)) return;
          a += 0.008;
          var r = hero.getBoundingClientRect();
          setLight(r.width * (0.5 + 0.32 * Math.sin(a)), r.height * (0.45 + 0.2 * Math.cos(a * 1.3)));
          window.requestAnimationFrame(loop);
        })();
      }
    });
  }

  /* Effets souris : boutons magnétiques et inclinaison des vitrines */
  function initFine() {
    if (!fine) return;
    all('.ct-btn').forEach(function (b) {
      if (!once(b, 'ctMagnet')) return;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.25) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.35) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
    all('.ct-frame').forEach(function (f) {
      if (!once(f, 'ctTilt')) return;
      f.addEventListener('mousemove', function (e) {
        var r = f.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        f.style.transform = 'perspective(900px) rotateY(' + ((x - 0.5) * 14) + 'deg) rotateX(' + ((0.5 - y) * 14) + 'deg)';
        f.style.setProperty('--gx', (x * 100) + '%');
        f.style.setProperty('--gy', (y * 100) + '%');
      });
      f.addEventListener('mouseleave', function () { f.style.transform = ''; });
    });
  }

  /* Panier : ajout sans recharger la page */
  function setCount(n) {
    var c = one('#ct-cart-count');
    if (c) c.textContent = n;
  }

  function showToast(msg) {
    var t = one('#ct-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('ct-show');
    window.clearTimeout(state.toastTimer);
    state.toastTimer = window.setTimeout(function () { t.classList.remove('ct-show'); }, 2600);
  }

  function flyDot(from) {
    var cart = one('#ct-cart');
    if (!cart || !from || !document.body.animate) return;
    var s = from.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    var dot = document.createElement('div');
    dot.className = 'ct-dot';
    dot.style.left = (s.left + s.width / 2) + 'px';
    dot.style.top = s.top + 'px';
    document.body.appendChild(dot);
    var anim = dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (c.left + c.width / 2 - s.left - s.width / 2) + 'px,' + (c.top - s.top) + 'px) scale(.3)', opacity: 0.8 }
    ], { duration: 800, easing: 'cubic-bezier(.5,0,.2,1)' });
    anim.onfinish = function () {
      dot.remove();
      cart.classList.remove('ct-bump');
      void cart.offsetWidth;
      cart.classList.add('ct-bump');
    };
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ct-add-form')) return;
    e.preventDefault();
    var btn = form.querySelector('.ct-add');
    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(form.getAttribute('action') || (root + 'cart/add'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, data: j }; });
    }).then(function (res) {
      if (!res.ok) { throw new Error((res.data && (res.data.description || res.data.message)) || ''); }
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      setCount(cart.item_count);
      var hd = one('.ct-header');
      if (hd) hd.classList.remove('ct-away');
      if (!reduce) flyDot(btn);
      showToast((form.getAttribute('data-title') || 'Article') + ' ajouté au panier');
    }).catch(function (err) {
      showToast(err && err.message ? err.message : "Impossible d'ajouter cet article");
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  }

  /* Écouteurs globaux (une seule fois) */
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    var h = de.scrollHeight - window.innerHeight;
    var bar = one('.ct-bar');
    if (bar) bar.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
    var hd = one('.ct-header');
    if (hd) hd.classList.toggle('ct-away', y > state.lastY && y > 120);
    state.lastY = y;
    var hi = one('.ct-hero-in');
    if (hi && !reduce && y < window.innerHeight * 1.2) {
      hi.style.transform = 'translateY(' + (y * 0.25) + 'px)';
      hi.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.9));
      all('.ct-leaf').forEach(function (l, i) { l.style.translate = '0 ' + (-y * (0.1 + i * 0.07)) + 'px'; });
    }
    lit();
  }

  function bindGlobals() {
    if (state.globals) return;
    state.globals = true;
    if (!one('.ct-bar')) {
      var bar = document.createElement('div');
      bar.className = 'ct-bar';
      bar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bar);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });
    window.addEventListener('resize', lit);
    document.addEventListener('submit', onSubmit);
    if (fine && !reduce) {
      var ring = document.createElement('div');
      ring.className = 'ct-ring';
      ring.setAttribute('aria-hidden', 'true');
      document.body.appendChild(ring);
      window.addEventListener('mousemove', function (e) {
        ring.classList.add('ct-on');
        ring.style.transform = 'translate(' + (e.clientX - ring.offsetWidth / 2) + 'px,' + (e.clientY - ring.offsetHeight / 2) + 'px)';
      });
      document.addEventListener('mouseover', function (e) {
        if (e.target.closest && e.target.closest('a,button,.ct-frame')) ring.classList.add('ct-big');
      });
      document.addEventListener('mouseout', function (e) {
        if (e.target.closest && e.target.closest('a,button,.ct-frame')) ring.classList.remove('ct-big');
      });
    }
    onScroll();
  }

  function init() {
    initManifesto();
    initHero();
    initReveal();
    initFine();
    bindGlobals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();